import { Icon } from '@chakra-ui/react';

export const LaptopIcon = (props: any) => (
  <Icon aria-label="laptop icon" viewBox="1 1 16 16" {...props}>
    <path
      d="m15 13.5v-.75c.825 0 1.4925-.675 1.4925-1.5l.0075-7.5c0-.825-.675-1.5-1.5-1.5h-12c-.825 0-1.5.675-1.5 1.5v7.5c0 .825.675 1.5 1.5 1.5v.75h-3v1.5h18v-1.5zm-12-9.75h12v7.5h-12z"
      fill="currentColor"
    />
  </Icon>
);
